<template>
  <div
    v-if="visible"
    class="zg-lookup"
  >
    <span class="label">
      {{ label }}
    </span>

    <span
      class="toggle"
      @click="toggle"
    >
      <zg-icon
        icon="edit"
        size="small"
        color="gray-500"
      />
    </span>
  </div>
</template>

<script>
  import ZgIcon from '../ZgIcon/ZgIcon.vue'

  export default {
    name: 'ZgLookup',
    components: {
      ZgIcon
    },
    props: {
      visible: {
        type: Boolean,
        required: false,
        default: false
      },
      label: {
        type: String,
        required: true
      }
    },
    methods: {
      toggle () {
        this.$emit('toggleLookup')
      }
    }
  }

</script>
<style lang="scss" scoped>
  .zg-lookup {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: input(padding-y) input(tooltip-width) input(padding-y) input(padding-x);
    background-color: color(white);
    width: 100%;
    height: 100%;
    z-index: 1;
    border-radius: radius(input);

    .label {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .toggle {
      position: absolute;
      top: 0;
      right: 0;
      cursor: pointer;
      width: input(tooltip-width);
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
